import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { FilterService } from '@ninety/platform/services';
import { SpinnerService, BecomeAPartnerIntercomActions } from '@ninety/platform/state';
import { AlertComponent, ButtonComponent } from '@ninety/ui/core';

@Component({
  selector: 'ninety-become-a-partner',
  templateUrl: './become-a-partner.component.html',
  styleUrls: ['./become-a-partner.component.scss'],
  standalone: true,
  imports: [ButtonComponent, AlertComponent],
})
export class BecomeAPartnerComponent implements OnInit, OnDestroy {
  private readonly spinnerService = inject(SpinnerService);
  private readonly filterService = inject(FilterService);
  private readonly store = inject(Store);

  constructor() {
    this.filterService.setOptions({ filtersToolbar: false });
    this.spinnerService.stop();
  }

  ngOnInit(): void {
    document.body.classList.add('partner-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('partner-page');
  }

  chatWithUs(): void {
    this.store.dispatch(BecomeAPartnerIntercomActions.showMessenger());
  }
}
